import JioIcon from 'assets/icons/Autopay/Jio.svg';
import AirtelIcon from 'assets/icons/Autopay/airtel.svg';
import ViIcon from 'assets/icons/Autopay/vi.svg';
import MtnlIcon from 'assets/icons/Autopay/mtnl.svg';
import BsnlIcon from 'assets/icons/Autopay/bsnl.svg';
import DefaultSimIcon from 'assets/icons/Autopay/DefaultSim.svg';
import { CarrierNames } from 'constants/upiConstants';

export const getSimLabel = (carrierName: string, slot: number) => {
	const updatedCarrierName = carrierName.toLowerCase();
	if (updatedCarrierName.includes(CarrierNames.Airtel)) {
		return {
			icon: AirtelIcon,
			name: 'Airtel',
		};
	}
	if (updatedCarrierName.includes(CarrierNames.Jio)) {
		return {
			icon: JioIcon,
			name: 'Jio',
		};
	}
	if (updatedCarrierName.includes(CarrierNames.Vi)) {
		return {
			icon: ViIcon,
			name: 'VI',
		};
	}
	if (updatedCarrierName.includes(CarrierNames.Mtnl)) {
		return {
			icon: MtnlIcon,
			name: 'MTNL',
		};
	}
	if (updatedCarrierName.includes(CarrierNames.Bsnl)) {
		return {
			icon: BsnlIcon,
			name: 'BSNL',
		};
	}
	return { icon: DefaultSimIcon, name: `SIM ${slot + 1}` };
};
